export default function Centered(props: {
  children: JSX.Element | JSX.Element[];
}) {
  return (
    <div className="flex grow flex-col justify-center">{props.children}</div>
  );
}
